<section class="page-offset section-pad">
  <div class="container">
    <div class="row g-4 align-items-center">
      <div class="col-lg-6">
        <h1 class="fw-bold">{{ i18n.t('contact.title') }}</h1>
        <p class="lead text-secondary">{{ i18n.t('contact.subtitle') }}</p>
        <p><i class="bi bi-envelope me-2 text-primary"></i>{{ contactEmail }}</p>
      </div>
      <div class="col-lg-6">
        <form class="soft-card bg-white p-4" (ngSubmit)="sendMessage()">
          <p class="required-fields-notice text-secondary small bg-light rounded-3 p-3 mb-3">{{ i18n.t('common.requiredFieldsNotice') }}</p>
          <label class="form-label" for="contactEmail">{{ i18n.t('common.email') }}<span class="required-star" aria-hidden="true">*</span></label>
          <input id="contactEmail" class="form-control mb-3" type="email" name="contactEmail" [(ngModel)]="email" [placeholder]="i18n.t('contact.emailPlaceholder')" [disabled]="isSubmitting" required>
          <label class="form-label" for="contactMessage">{{ i18n.t('contact.messageLabel') }}<span class="required-star" aria-hidden="true">*</span></label>
          <textarea id="contactMessage" class="form-control mb-3" rows="5" name="contactMessage" [(ngModel)]="message" [placeholder]="i18n.t('contact.messagePlaceholder')" [disabled]="isSubmitting" required></textarea>
          <div class="mb-3">
            <altcha-widget
              name="altcha"
              [attr.challenge]="captchaChallengeUrl"
              (statechange)="onCaptchaStateChange($event)">
            </altcha-widget>
            @if (captchaError) { <div class="form-text text-danger">{{ i18n.t('contact.captchaLoadError') }}</div> }
          </div>
          @if (status === 'invalid') { <div class="alert alert-warning py-2">{{ i18n.t('contact.validationError') }}</div> }
          @if (status === 'captcha') { <div class="alert alert-warning py-2">{{ i18n.t('contact.captchaRequired') }}</div> }
          @if (status === 'sent') { <div class="alert alert-success py-2">{{ i18n.t('contact.messageSent') }}</div> }
          @if (status === 'error') { <div class="alert alert-danger py-2">{{ i18n.t('contact.sendError') }}</div> }
          <button class="btn btn-primary" type="submit" [disabled]="isSubmitting" [attr.aria-busy]="isSubmitting">
            @if (isSubmitting) { <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span> }
            <span>{{ isSubmitting ? i18n.t('contact.sendingMessage') : i18n.t('contact.sendMessage') }}</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</section>
